import { render, staticRenderFns } from "./sign-on.vue?vue&type=template&id=1d24cc15&"
import script from "./sign-on.vue?vue&type=script&lang=js&"
export * from "./sign-on.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports